module.exports = __webpack_public_path__ + "img/ic_next.573981d3.svg";